/* eslint-disable complexity */
import { v4 as uuidv4 } from 'uuid';

function getHeaders() {
  const uniqueId = uuidv4();
  return {
    'Request-Id': uniqueId,
    'correlation-id': uniqueId,
    'one-data-correlation-id': uniqueId,
    'Content-Type': 'application/json',
  };
}

export async function callFxgApi(apiUrl, methodType, requestData) {
    let response = null;
    let hasErrors = true;
    let status = null;
    let apiResponse = {};

    if (apiUrl) {
      try {
        const requestCommonData = {
          requestId: uuidv4(),
        };
        if (methodType === 'POST' || methodType === 'PUT') {
          apiResponse = await fetch(apiUrl, {
            method: methodType,
            headers: getHeaders(),
            credentials: 'include',
            body: JSON.stringify({ ...requestCommonData, ...requestData }),
          });
        } else if (methodType === 'GET' || methodType === 'DELETE') {
          apiResponse = await fetch(apiUrl, {
            method: methodType,
            headers: getHeaders(),
            credentials: 'include',
          });
        }
        if (!apiResponse.ok) {
          const message = `An error has occured: ${apiResponse.status}`;
          if (
            apiResponse.status === 400
            || apiResponse.status === 401
            || apiResponse.status === 422
            || apiResponse.status === 500
          ) {
            response = await apiResponse?.json();
            hasErrors = true;
            status = apiResponse.status;
          } else {
            throw new Error(message);
          }
        } else {
          response = await apiResponse.json().catch((err) => {
            console.error('Error parsing success response', err);
            return {};
          });
          hasErrors = false;
          status = apiResponse.status;
        }
      } catch (exe) {
        console.error(exe);
        hasErrors = true;
        status = apiResponse.status;
      }
    }
    return {
      response,
      hasErrors,
      status,
    };
  }
